<template>
  <div class="container">
    <div class="ruleicon" @click="rulePopupShow = true">规则</div>
    <img class="dlicon" @click="dlFn" src="@/assets/img2/venuetwo-dl.png" />

    <img class="fdkh" src="@/assets/img2/venuethree-fldh.png" />
    <img class="fdkhtime" src="@/assets/img2/venueone-fdkhtime.png" />

    <div class="cardbox">
      <div class="carditem carditem1">
        <div class="left">
          <div class="title">我的积分</div>
          <div class="num">8</div>
        </div>
        <img class="icon" src="@/assets/img2/venuethree-icon1.png" />
      </div>
      <div class="carditem">
        <div class="left">
          <div class="title">我的徽章</div>
          <div class="num">2</div>
        </div>
        <img class="icon" src="@/assets/img2/venuethree-icon2.png" />
      </div>
    </div>

    <div class="tabs">
      <img class="textimg" v-if="activeTab == 'zrw'" src="@/assets/img2/venuethree-zrw-active.png" />
      <img class="textimg" v-else src="@/assets/img2/venuethree-zrw.png" @click="activeTab = 'zrw'" />
      <img class="textimg textimg2" v-if="activeTab == 'hzq'" src="@/assets/img2/venuethree-hzq-active.png" />
      <img class="textimg textimg2" v-else src="@/assets/img2/venuethree-hzq.png" @click="activeTab = 'hzq'" />
    </div>

    <div class="zrwbox" v-if="activeTab == 'zrw'">
      <img class="zrwtitle" src="@/assets/img2/venuethree-zrw-title.png" />
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon3.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon4.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon5.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon6.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon7.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
      <div class="zrwitem">
        <div class="left">
          <img class="icon" src="@/assets/img2/venuethree-icon3.png" />
          <div class="desbox">
            <div class="des1">健康知识答题</div>
            <div class="des2">有机会获得3积分</div>
          </div>
        </div>
        <div class="btn">去答题</div>
      </div>
    </div>

    <div class="hzqbox" v-else>
      <div class="hzqcon" v-for="(item, i) in hdHzqList" :key="i">
        <div class="hzqitem card-front" :class="{ 'flipped': item.dire }">
          <div class="linetitle">
            <img class="icon" src="@/assets/img2/home-iconL.png" />
            <div class="hzname">{{ item.name }}</div>
            <img class="icon" src="@/assets/img2/home-iconR.png" />
          </div>
          <img class="hzimg" :src="item.icon" />
          <div class="line"></div>
          <div class="linedes">{{ item.des }}</div>
          <div class="btnbox" @click="hzFn(i)">
            <img class="fzicon" src="@/assets/img2/venuetwo-result-icon.png" alt="">
            <div>翻页有惊喜</div>
          </div>
        </div>
        <div class="hzqitem hzqitemfz card-back" :class="{ 'flipped': item.dire }">
          <div class="proName">无忧保plus百万医疗保险 （互联网专属）</div>
          <div class="des2">保障全保费低 多人价格实惠</div>
          <div class="proimgbox">
            <img class="proimg" src="@/assets/img2/insure1.png" alt="">
            <div class="ljxg">立即选购</div>
          </div>
          <div class="pricebox">
            <span class="unit">￥</span><span class="price">188</span><span>元</span>
          </div>
          <div class="btnbox" @click="hzFn(i)">
            <img class="fzicon" src="@/assets/img2/venuetwo-result-icon.png" alt="">
            <div>翻页看徽章</div>
          </div>
        </div>
      </div>
    </div>

    <common ref="commonComponent" />


    <!-- 关注公众号 -->
    <van-popup v-model="gzhPopupShow" position="center" :close-on-click-overlay="false" class="custom-popup-gzh">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title3.png" alt="">
        <img class="logo" src="@/assets/img2/logo.png" alt="">
        <img class="ewm" :src="gzhImg" alt="">
        <div class="des">（长按关注紫金保险官方公众号参与活动）</div>
      </div>
    </van-popup>

    <!-- 活动规则 -->
    <van-popup v-model="rulePopupShow" position="center" :close-on-click-overlay="false"
      class="custom-popup-gzh custom-popup-rule">
      <img class="topimg" src="@/assets/img2/home-popup-top.png" alt="">
      <div class="popup-content">
        <img class="titleimg" src="@/assets/img2/home-popup-title2.png" alt="">
        <div class="textbox">
          <div class="text">
            1.紫金保险会员每日登录可获得1次免费开福袋机会；
          </div>
          <div class="text">
            2.点击福袋，福袋打开，弹出对应奖品；
          </div>
          <div class="text">
            3.连续签到奖励：连续签到 3 天、7 天可额外获得 1 次开福袋机会;
          </div>
          <div class="text">
            4.分享奖励：分享活动给好友，好友参与后分享者额外获得 1 次机会
          </div>
        </div>
        <img class="btn" src="@/assets/img2/home-btn.png" alt="" @click="rulePopupShow = false">
      </div>
    </van-popup>
  </div>
</template>

<script>
import { badges, getPersonApi, userPoints, zfLj, getActApi, postConfigApi, trackingMonitor, loginApi, shareApi } from '@/api/index'

import { getPageLlq } from '@/utils/index.js'
import common from './common.vue'
export default {
  components: { common },
  data() {
    return {
      num: 0,
      rulePopupShow: false,
      gzhPopupShow: false,
      gzhImg: require('@/assets/img2/' + process.env.VUE_APP_ZKING_GZHIMG + '.png'),
      resultPopupShow: false,

      productName: '金龙鱼礼盒',
      activeTab: 'zrw',
      ddts: 0,
      current: 2,
      result: 'error',

      hdHzqList: [
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz1.png'), dire: false, },
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz2.png'), dire: false, },
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz3.png'), dire: false, },
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz4.png'), dire: false, },
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz5.png'), dire: false, },
        { name: '智慧之星', des: '完成1次答题（全对）', icon: require('../assets/img2/hz6.png'), dire: false, },
      ],




      resultcard: 'hz',
      isFlipped: false, // 新增：控制翻转状态
    }
  },
  created() {
    console.log('venuethree页面参数',this.$route.query);
    this.pageLlq = getPageLlq()
    // 判断链接中是否含有token
    if (this.$route.query.return_zking_info) {
      loginApi({
        utoken: this.$route.query.return_zking_info,
      }).then((res) => {
        localStorage.setItem('Authorization', res.data.accessToken)
        this.getPersonData()
        this.getMybadges()
      });
    } else {
      this.getPersonData()
      this.getMybadges()
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    // 获取我的徽章
    getMybadges() {
      badges().then((res) => {
        this.myBadges = res.data
      });
    },
    hzFn(i) {
      this.hdHzqList[i].dire = !this.hdHzqList[i].dire
    },
    dlFn() {
      this.$refs.commonComponent.scrollFn()
    },

    // 获取个人信息
    getPersonData() {
      getPersonApi().then((res) => {
        if (res.code == 1006000000) {
          this.gzhPopupShow = true
        } else {
          this.gzhPopupShow = false
        }
        // this.zkToken = res.data.zkToken
      });
    },

    getuserPoints() {
      userPoints().then(res => {
        this.chances = res.data.chances
        this.points = res.data.points
        this.dailyBlessingSy = res.data.dailyBlessingSy
        this.allZf = res.data.allZf

        if (localStorage.getItem('lovenum')) {
          this.totalAx = res.data.totalAx - 1
          setTimeout(() => { this.showgif = true }, 100)
          setTimeout(() => {
            this.showgif = false
            this.totalAx = res.data.totalAx
            localStorage.removeItem('lovenum')
          }, 2000)
        } else {
          this.totalAx = res.data.totalAx
        }
      })
    },
  },

  beforeDestroy() {
  },
}
</script>

<style lang="less" scoped>
.container {
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
  padding: 9px 0 0px 0;
  background: linear-gradient(180deg, #8833EF 0%, #B675F8 50.86%, #ECCAFA 100%);

  display: flex;
  flex-direction: column;
  align-items: center;

  .ruleicon {
    top: 60px;
  }

  .dlicon {
    top: 40px;
  }


  .fdkh {
    width: 232px;
  }

  .fdkhtime {
    margin-top: 5px;
    width: 300px;
  }

  .cardbox {
    display: flex;
    margin-top: 17px;

    .carditem {
      width: 163px;
      height: 70px;
      padding: 0px 16px;
      box-sizing: border-box;
      background: linear-gradient(90deg, #FFFFFF 0%, #FEFBF6 100%);
      border-radius: 10px 10px 10px 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;

      .title {
        font-size: 16px;
        color: #111111;
      }

      .num {
        font-weight: 500;
        font-size: 24px;
        color: #FB9F1D;
      }

      .icon {
        width: 29px;
        height: 29px;
      }
    }

    .carditem1 {
      margin-right: 15px;
    }
  }

  .tabs {
    margin: 18px 0;
    display: flex;

    .textimg {
      width: 175px;
    }

    .textimg2 {
      margin-left: -8px;
    }
  }


  .zrwbox {
    width: 343px;
    padding: 20px 14px 10px 14px;
    box-sizing: border-box;
    background: linear-gradient(180deg, #FFF6BF 0%, #FFFFFF 12.37%);
    border-radius: 10px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .zrwtitle {
      width: 244px;
      margin-bottom: 10px;
    }

    .zrwitem {
      width: 100%;
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        display: flex;
        align-items: center;

        .icon {
          width: 55px;
          height: 55px;
          margin-right: 9px;
        }

        .des1 {
          font-weight: 500;
          font-size: 16px;
          color: #474747;
        }

        .des2 {
          font-weight: 400;
          font-size: 12px;
          color: #8D8C8C;
        }
      }

      .btn {
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        padding: 5px 16px 7px 16px;
        background: linear-gradient(180deg, #FFC466 0%, #FD8F00 100%);
        border-radius: 25px 25px 25px 25px;
      }
    }
  }

  .hzqbox {
    padding: 0 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .hzqcon {
      width: 165px;
      height: 210px;
      margin-bottom: 16px;
      perspective: 1000px; // 设置视距，产生3D效果
      position: relative;

      .hzqitem {
        width: 100%;
        height: 100%;
        padding: 6px 16px 0 16px;
        box-sizing: border-box;
        background-image: url(../assets/img2/hzqbg.png);
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-family: HelloFont WenYiHei, HelloFont WenYiHei;
        font-size: 16px;
        color: #FFFFFF;

        position: absolute; // 绝对定位使两面重叠
        backface-visibility: hidden; // 关键：背面不可见
        transition: transform 0.9s ease-in-out; // 翻转动画过渡
        transform-style: preserve-3d;

        // 默认状态
        &.card-front {
          transform: rotateY(0deg);
          z-index: 2;
        }

        &.card-back {
          transform: rotateY(180deg); // 背面初始旋转180度
          z-index: 1;
        }

        // 翻转后的状态
        &.flipped {
          &.card-front {
            transform: rotateY(-180deg); // 正面向左翻转180度
          }

          &.card-back {
            transform: rotateY(0deg); // 背面转回0度，变为正面
          }
        }

        .linetitle {
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            width: 22px;
          }

          .hzname {
            font-weight: 600;
            margin: 0 10px;
          }
        }

        .hzimg {
          width: 81px;
          height: 72px;
          margin: 13px 0 1px 0;
        }

        .line {
          width: 44px;
          height: 3px;
          margin: 3px 0 5px 0;
          background: linear-gradient(90deg, rgba(255, 236, 186, 0) 0%, #FFECBA 32.21%, rgba(255, 236, 186, 0) 100%);
        }

        .linedes {
          font-size: 10px;
          color: #1F1F1F;
        }

        .btnbox {
          margin-top: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 10px;
          color: #FFFFFF;
          background: #FBB142;
          border-radius: 21px 21px 21px 21px;
          padding: 3px 7px 5px 7px;

          .fzicon {
            width: 10px;
            margin: 2px 3px 0 0;
          }
        }
      }

      .hzqitemfz {
        .proName {
          font-weight: bold;
          font-size: 12px;
          color: #FFFFFF;
          text-align: center;
        }

        .des2 {
          font-size: 8px;
          color: #4B4B4B;
          margin: 4px 0 8px 0;
        }

        .proimgbox {
          width: 58px;
          height: 49px;
          position: relative;

          img {
            width: 100%;
            height: 100%;
          }

          .ljxg {
            position: absolute;
            left: 12px;
            top: 18px;
            background: rgba(92, 92, 92, 0.79);
            border-radius: 17px 17px 17px 17px;
            font-size: 7px;
            color: #FFFFFF;
            padding: 1px 5px 3px 5px;
          }
        }

        .pricebox {
          margin: 4px 0 9px 0;
          color: #343338;
          font-size: 8px;

          .unit {
            font-weight: 500;
            font-size: 8px;
            color: #FF4C46;
          }

          .price {
            font-size: 10px;
            color: #FF4C46;
          }
        }

        .btnbox {
          margin-top: 0;
        }
      }
    }

    .hzimg {
      width: 165px;
      height: 210px;
      margin-bottom: 16px;
    }
  }
}
</style>
